import { render, staticRenderFns } from "./upload-video.vue?vue&type=template&id=08fd7670&scoped=true&"
import script from "./upload-video.vue?vue&type=script&lang=js&"
export * from "./upload-video.vue?vue&type=script&lang=js&"
import style0 from "./upload-video.vue?vue&type=style&index=0&id=08fd7670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fd7670",
  null
  
)

export default component.exports